<template>
    <div class="rtportal">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  mounted: function() {
    //
    this.updateTableHeight();

    window.onresize = () => {
      this.updateTableHeight();
    };
  },
  methods: {
    updateTableHeight() {
      var documentHeight = document.body.clientHeight;
      this.$store.commit("UPDATE_TABLE_HEIGHT", documentHeight - 300);
    }
  }
};
</script>



// WEBPACK FOOTER //
// App.vue?2327a1a2